module.exports = __webpack_public_path__ + "img/1686882868847-03d9ef2c-d274-4d23-937f-620b66350374.jpeg.faf19f06.webp";